import { createMuiTheme } from '@material-ui/core';

export const AGREEMENT_TERMS_THEME = createMuiTheme({
    overrides: {
        MuiTypography: {
            root: {
                marginLeft: '3%'
            },
            h6: {
                fontSize: '0.9rem',
                marginTop: '1%'
            },
            h5: {
                color: 'rgba(40, 90, 171, 0.87)',
                paddingTop: '3%'
            }
        },
        MuiPrivateTextArea: {
            root: {
                width: '98%'
            }
        },
        MuiFormControlLabel: {
            root: {
                width: '50%'
            }
        },
        MuiOutlinedInput: {
            multiline: {
                marginRight: '5%'
            }
        },
        MuiGrid: {
            item: {
                marginLeft: '3%'
            }
        },
        MuiPaper: {
            rounded: {
                width: '50%',
                marginLeft: '25%',
                marginTop: '2.75%'
            },
            elevation1: {
                boxShadow:
                    '0px 1px 3px 0px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.01), 0px 2px 1px -1px rgba(0,0,0,0)'
            }
        },
        MuiCheckbox: {
            root: {
                '&$checked': {
                    color: '#002D5B !important'
                }
            }
        },
        MuiInputLabel: {
            outlined: {
                transform: 'translate(14px, 10px) scale(1)'
            }
        },
        MuiTableCell: {
            head: {
                color: '#000',
                fontSize: '0.95rem',
                fontWeight: 500,
                borderBottom: '1px solid #005F9E'
            },
            body: {
                fontSize: '0.94rem'
            }
        },
        MuiInputBase: {
            fullWidth: {
                width: '95%'
            },
            input: {
                padding: '8.5px 10px !important',
                fontSize: '14px',
                '&$disabled': {
                    fontSize: '14px',
                    color: 'black'
                }
            }
        }
    }
});

export const AGREEMENT_REPORT_THEME = createMuiTheme({
    overrides: {
        MuiPaper: {
            rounded: {
                height: '100%'
            },
            root: {
                minHeight: '600px',
                backgroundColor: '#F3F3F7'
            }
        },
        MuiTabs: {
            indicator: {
                backgroundColor: 'rgb(0, 145, 234) !important'
            }
        },
        MuiTab: {
            textColorPrimary: {
                '&$selected': {
                    color: 'rgb(0, 145, 234) !important',
                    backgroundColor: '#fff !important'
                }
            },

            wrapper: {
                fontFamily: 'Open Sans, sans-serif',
                fontWeight: 'bold'
            }
        },

        MuiGrid: {
            container: {
                padding: '20px',
                backgroundColor: '#fff'
            }
        },
        MuiDataTableHeadCell: {
            fontWeight: 600
        },
        MuiTypography: {
            h5: {
                color: '#2ECCFA',
                marginLeft: '39%',
                fontSize: '2rem',
                fontWeight: 800
            }
        }
    }
});

export const AGREEMENT_DROPDOWN_THEME = createMuiTheme({
    overrides: {
        MuiPaper: {
            rounded: {
                height: '18%'
            }
        },
        MuiTableCell: {
            head: {
                fontWeight: 500,
                fontSize: '0.85rem',
                color: 'rgba(0, 0, 0, 1)'
            }
        }
    }
});
